<script setup lang="ts">
import { ReportTablePresenter, type ReportColumn, type ReportRow } from '@/features/reports'
import { useI18n } from '@/shared/i18n'

withDefaults(
  defineProps<{
    rows: ReportRow[]
    columns: ReportColumn[]
    total?: Record<string, unknown> | null
    preview?: boolean
  }>(),
  { total: null, preview: false },
)
const { t } = useI18n()
</script>

<template>
  <ReportTablePresenter
    v-if="rows.length > 0 && columns.length > 0"
    :rows="preview ? rows.slice(0, 3) : rows"
    :columns="columns"
    :total="total"
    v-bind="{
      ariaLabel: preview ? t('orpheus.message.reportPreview') : t('orpheus.answer.tableLabel'),
      ...(preview ? { maxHeight: '12rem' } : {}),
    }"
    :allow-column-resize="!preview"
  />
  <p v-else class="answer-table__empty m-0 p-xl text-muted text-center">
    {{ t('orpheus.answer.empty') }}
  </p>
</template>
